import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import {Provider} from "react-redux";
import store from "./store";
import {setAuthToken} from "./utils/utils";
import {setCurrentUser} from "./store/actions/auth";

const token = localStorage.getItem('token');
// Check for token
if (token) {
  setAuthToken(token);
  // Decode and get user
  const user = JSON.parse(atob(localStorage.getItem('user')));
  store.dispatch(setCurrentUser(user));
}

ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path="/" component={App}/>
        </Switch>
      </BrowserRouter>
    </Provider>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js